const CRM_Reducer = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default CRM_Reducer;
